import ConfirmationModal from 'hb-react/shared/components/DesignSystem/Modal/ConfirmationModal';

import { type ConfirmModalProps } from '../types';

export const ConfirmModal = ({
  isEditingPost,
  isOpen,
  onCloseModal,
  setDisplayConfirmModal,
}: ConfirmModalProps) => {
  const text = isEditingPost
    ? s__(
        'LiveFeed|Your changes will be discarded. Are you sure you want to exit?',
      )
    : s__(
        'LiveFeed|Your draft will be discarded. Are you sure you want to exit?',
      );

  const title = isEditingPost
    ? s__('LiveFeed|Discard changes')
    : s__('LiveFeed|Discard draft');

  return isOpen ? (
    <ConfirmationModal
      confirmButtonLabel={title}
      onCloseModal={() => setDisplayConfirmModal(false)}
      onConfirmation={onCloseModal}
      text={text}
      title={title}
    />
  ) : null;
};
